import { Lesson } from '../types';

export const calculateProgress = (lessons: Lesson[]): number => {
    if (!lessons.length || lessons.length === 0) return 0;
    const completed = lessons.filter(lesson => lesson.completed).length;
    return Math.round((completed / lessons.length) * 100);
}; 